import React, { useState, Fragment, useContext } from 'react';

import {
  Box,
  List,
  Divider,
  ListItem,
  Typography,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';

import { useStyles, listTextStyles, listItemsStyles } from './LocationsWidget.styled';

import i18n from 'i18n-js';
import Can from 'components/Can';
import { Card } from 'components/UI';
import { UserContext } from 'context';
import Loading from 'components/Loading';
import Paginator from 'components/Paginator';
import { withRouter } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { ChangeLocationsModal } from 'components/Modals';

const LocationsWidget = ({
  locations,
  pagination,
  params,
  onDelete,
  steps,
  loading,
  currentGroup,
  handleChangePage,
}) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const listItemsClasses = listItemsStyles();
  const { orgType } = useContext(UserContext);
  const [open, setOpen] = useState(false);

  const handleLocationsModalOpen = () => {
    setOpen((prevState) => !prevState);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('locations.edit'),
      can: { name: 'vehicle_group', action: 'update' },
      onClick: handleLocationsModalOpen,
    },
  ];

  const onDeleteClick = (item) => {
    const locationId = item.id;
    onDelete(locationId);
  };

  const getType = () => {
    if (orgType === 'msServiceOrg' || orgType === 'plainOrg') {
      return 'customers';
    }
    return 'service';
  };

  return (
    <Card
      menuItems={items}
      headerActionType="vertical"
      data-cy="locations-widget-card"
      title={i18n.t('locations.title')}
    >
      {loading ? (
        <Box
          className={classes.loadingContainer}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Loading />
        </Box>
      ) : (
        <>
          <Box className={classes.cardContentPadding}>
            {locations?.length > 0 ? (
              <>
                <List className={classes.list} data-cy="locations-widget-card-list">
                  {locations?.map((val, index) => (
                    <Fragment key={index}>
                      <ListItem>
                        <ListItemText classes={listClasses} primary={`${val.name}`} />
                        <ListItemSecondaryAction classes={listItemsClasses}>
                          <Can I="update" a="vehicle_group">
                            <Box fontSize={13}>
                              <IconButton onClick={handleLocationsModalOpen}>
                                <EditIcon
                                  style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }}
                                />
                              </IconButton>
                            </Box>
                          </Can>
                          <Can I="update" a="vehicle_group">
                            <Box fontSize={13}>
                              <IconButton onClick={() => onDeleteClick(val)}>
                                <DeleteIcon
                                  style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }}
                                />
                              </IconButton>
                            </Box>
                          </Can>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider className={classes.divider} />
                    </Fragment>
                  ))}
                </List>
                <Paginator
                  component="div"
                  limit={params.limit}
                  pagination={pagination}
                  onPageChange={handleChangePage}
                />
              </>
            ) : (
              <Typography color="textPrimary" style={{ lineHeight: 1 }}>
                <Box fontSize={14} component="span" lineHeight={1}>
                  {i18n.t('vehicle_groups.no_locations')}
                </Box>
              </Typography>
            )}
          </Box>
        </>
      )}
      {open && (
        <ChangeLocationsModal
          open={open}
          steps={steps}
          type={getType()}
          currentGroup={currentGroup}
          handleClick={handleLocationsModalOpen}
        />
      )}
    </Card>
  );
};

export default withRouter(LocationsWidget);
